/** Display labels for quote header margin toggle (non-excluded / calculated margin view). */
export const ONE_TIME_NON_EXCLUDED_PROFIT_LABEL = "Non-Excluded Gross Profit";
export const ONE_TIME_NON_EXCLUDED_MARGIN_LABEL = "Non-Excluded Gross Margin";

export const getRecurringNonExcludedProfitLabel = (recurringPrefix) => {
	const prefix =
		recurringPrefix === "Annual" || recurringPrefix === "Monthly"
			? `${recurringPrefix} `
			: "";
	return `${prefix}Non-Excluded Recurring Gross Profit`;
};

export const getRecurringNonExcludedMarginLabel = (recurringPrefix) => {
	const prefix =
		recurringPrefix === "Annual" || recurringPrefix === "Monthly"
			? `${recurringPrefix} `
			: "";
	return `${prefix}Non-Excluded Recurring Gross Margin`;
};
